import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { BaseComponent } from '@shared/components/base/base-component/base.component';
import { HomeCardComponent } from '@shared/components/home-card/home-card.component';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { stagger80ms } from '@vex/animations/stagger.animation';
import { map } from 'rxjs';
import {
  NavigationLink,
  NavigationSubheading,
} from '../../../core/navigation/navigation-item.interface';

@Component({
    selector: 'app-admin-controle-acessos',
    imports: [AsyncPipe, HomeCardComponent],
    templateUrl: './admin-controle-acesso.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeInUp400ms, stagger80ms]
})
export class AdminControleAcessosComponent
  extends BaseComponent
  implements OnInit
{
  protected cards$ = this.navigationService.itemsAdmin$.pipe(
    map((items) => {
      const comissoesItems = items.find(
        (item) => item.type === 'subheading' && item.id === 'acesso' 
      ) as NavigationSubheading;
      const comissoesLinks = comissoesItems.children;
      return (comissoesLinks || []) as NavigationLink[];
    })
  );

  ngOnInit(): void {
    this.setBreadcrumbs([]);
  }
}
